import { Icon, Text, TextLink, Tooltip } from '@ui/themed';
import { t } from 'i18next';
import { INTERCOM_TRIGGER } from '../../../constants/intercom';
import { cn } from '../../../lib/styles';
import type { PlanPoint } from '../types/plan';

type BulletPointProps = {
  point: PlanPoint;
  showNeedMore?: boolean;
};

export function BulletPoint({ point, showNeedMore }: BulletPointProps) {
  const isOrdersPoint = /orders\s*\/\s*mo/i.test(point.text);

  const content = (
    <div className="flex items-center gap-2">
      <Icon name="check" size="sm" />
      <Text variant="secondary">
        {point.text}
        {isOrdersPoint && showNeedMore && (
          <span className={cn('ms-1', { [INTERCOM_TRIGGER.enterpriseChat]: true })}>
            <TextLink onClick={() => {}} variant="secondary">
              {t('features:billing.components.plan_card.bullets.need_more')}
            </TextLink>
          </span>
        )}
      </Text>
    </div>
  );

  if (point.description) {
    return (
      <div className="cursor-help">
        <Tooltip content={point.description}>{content}</Tooltip>
      </div>
    );
  }

  return content;
}

export function PlanCardBullets({
  points,
  showNeedMore,
}: {
  points: PlanPoint[];
  showNeedMore: boolean;
}) {
  return (
    <div className="flex flex-col gap-1">
      {points.map((point) => (
        <BulletPoint key={point.text} point={point} showNeedMore={showNeedMore} />
      ))}
    </div>
  );
}
